import React, {Component} from 'react';
import styles from './KnowSection.scss';
import classNames from 'classnames/bind';
import {action, observable} from 'mobx';
import {observer} from 'mobx-react';
import TimelineMax from 'TimelineMax';
import ScrollMagic from 'ScrollMagic';
import 'animation.gsap';
import knowDisplayUI from 'assets/images/awair/know-display-ui.png';

const cx = classNames.bind(styles);

class KnowStore {
  @observable dormant = true;

  @action activeDormant = () => this.dormant = true;
  @action unactiveDormant = () => this.dormant = false;
}

const knowStore = new KnowStore();

@observer
class KnowSection extends Component {
  handleSceneAnimation = () => {
    const {activeDormant, unactiveDormant} = knowStore;

    const knowController = new ScrollMagic.Controller();

    const knowRevealAnimation = new TimelineMax();
    knowRevealAnimation.fromTo('#know-intro', 1,  {y: 50, autoAlpha: 0},{y: 0, autoAlpha: 1});
    knowRevealAnimation.fromTo('#know-display-ui', 1, {y: 50, autoAlpha: 0},{y: 0, autoAlpha: 1}, '-=0.5');

    new ScrollMagic.Scene({
      triggerElement: '#know',
      triggerHook: 'onEnter',
      offset: 300
    })
      .setTween(knowRevealAnimation)
      .addTo(knowController);

    const knowHideDisplayUIAnimation = new TimelineMax();
    knowHideDisplayUIAnimation.to('#know-display-ui img', 1, {autoAlpha: 0});

    new ScrollMagic.Scene({
      triggerElement: '#know',
      duration: '40%',
      offset: window.innerHeight * 0.75
    })
      .setTween(knowHideDisplayUIAnimation)
      .addTo(knowController);

    new ScrollMagic.Scene({
      triggerElement: '#know-awair-overlay-array',
      offset: -100
    })
      .on('enter', () => {
        unactiveDormant();
      })
      .on('leave', function() {
        activeDormant();
      })
      .addTo(knowController)
  };

  componentDidMount() {
    this.handleSceneAnimation();
  }

  render() {
    const {dormant} = knowStore;

    return (
      <section className={cx('know')} id="know">
        <div className={cx('know-intro')} id="know-intro">
          <h2>空気を可視化する</h2>
          <p><span lang='en-thin'>Awair</span>アプリを通して空気がどんな状態なのか、一目で確認してみましょう</p>
        </div>
        <div className={cx('know-display-ui')} id="know-display-ui">
          <img src={knowDisplayUI} alt='awair display' />
        </div>
        <div className={cx('know-awair-overlay')}>
          <div className={cx('dot-array', dormant && 'dormant')} id="know-awair-overlay-array">
            <div className={cx('factor-column', 'factor-column-temp')}>
              <span className={cx('dot', 'y5')} />
              <span className={cx('dot', 'y4')} />
              <span className={cx('dot', 'y3')} />
              <span className={cx('dot', 'y2')} />
              <span className={cx('dot', 'y1')} />
              <span className={cx('ttip')}>温度</span>
            </div>
            <div className={cx('factor-column', 'factor-column-hum')}>
              <span className={cx('dot', 'y5')} />
              <span className={cx('dot', 'y4')} />
              <span className={cx('dot', 'y3')} />
              <span className={cx('dot', 'y2')} />
              <span className={cx('dot', 'y1')} />
              <span className={cx('ttip')}>湿度</span>
            </div>
            <div className={cx('factor-column', 'factor-column-co2')}>
              <span className={cx('dot', 'y5')} />
              <span className={cx('dot', 'y4')} />
              <span className={cx('dot', 'y3')} />
              <span className={cx('dot', 'y2')} />
              <span className={cx('dot', 'y1')} />
              <span className={cx('ttip')}>二酸化炭素</span>
            </div>
            <div className={cx('factor-column', 'factor-column-chem')}>
              <span className={cx('dot', 'y5')} />
              <span className={cx('dot', 'y4')} />
              <span className={cx('dot', 'y3')} />
              <span className={cx('dot', 'y2')} />
              <span className={cx('dot', 'y1')} />
              <span className={cx('ttip')}>化学物質(<span lang='en-thin'>VOC</span>)</span>
            </div>
            <div className={cx('factor-column', 'factor-column-dust')}>
              <span className={cx('dot', 'y5')} />
              <span className={cx('dot', 'y4')} />
              <span className={cx('dot', 'y3')} />
              <span className={cx('dot', 'y2')} />
              <span className={cx('dot', 'y1')} />
              <span className={cx('ttip')}>ホコリ</span>
            </div>
            <div className={cx('score-digits')}>
              <div className={cx('score-digit', 'score-digit-tens')}>
                <span className={cx('dot', 'x1', 'y5')} /><span className={cx('dot', 'x2', 'y5')} /><span className={cx('dot', 'x3', 'y5')} />
                <span className={cx('dot', 'x1', 'y4')} /><span className={cx('dot', 'x2', 'y4')} /><span className={cx('dot', 'x3', 'y4')} />
                <span className={cx('dot', 'x1', 'y3')} /><span className={cx('dot', 'x2', 'y3')} /><span className={cx('dot', 'x3', 'y3')} />
                <span className={cx('dot', 'x1', 'y2')} /><span className={cx('dot', 'x2', 'y2')} /><span className={cx('dot', 'x3', 'y2')} />
                <span className={cx('dot', 'x1', 'y1')} /><span className={cx('dot', 'x2', 'y1')} /><span className={cx('dot', 'x3', 'y1')} />
              </div>
              <div className={cx('score-digit', 'score-digit-ones')}>
                <span className={cx('dot', 'x1', 'y5')} /><span className={cx('dot', 'x2', 'y5')} /><span className={cx('dot', 'x3', 'y5')} />
                <span className={cx('dot', 'x1', 'y4')} /><span className={cx('dot', 'x2', 'y4')} /><span className={cx('dot', 'x3', 'y4')} />
                <span className={cx('dot', 'x1', 'y3')} /><span className={cx('dot', 'x2', 'y3')} /><span className={cx('dot', 'x3', 'y3')} />
                <span className={cx('dot', 'x1', 'y2')} /><span className={cx('dot', 'x2', 'y2')} /><span className={cx('dot', 'x3', 'y2')} />
                <span className={cx('dot', 'x1', 'y1')} /><span className={cx('dot', 'x2', 'y1')} /><span className={cx('dot', 'x3', 'y1')} />
              </div>
              <span className={cx('ttip')}><span lang='en-thin'>Awair</span>スコア</span>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default KnowSection;


// WEBPACK FOOTER //
// ./src/app/components/organisms/KnowSection/KnowSection.js